import React from 'react'
import { RunContextItem } from '../../../store/customWorkflow/customWorkflows'
import { RunContextItemLink } from './RunContextItemLink'

export interface RunContextDetailProps {
  context?: RunContextItem[]
  accountId: string
}

const itemKey = (item: RunContextItem, index: number): string =>
  `${item.kind}-${item.contactId ?? item.executionId ?? item.aiAgentResultKey ?? item.eventType ?? index}`

export const RunContextDetail: React.FC<RunContextDetailProps> = ({ context, accountId }) => {
  if (!context || context.length === 0) return null
  return (
    <div className='mb-3'>
      <div className='paragraph-small zocks-text-gray-600 mb-1'>Run for</div>
      <div className='d-flex flex-column zocks-gap-1'>
        {context.map((item, index) => (
          <RunContextItemLink key={itemKey(item, index)} item={item} accountId={accountId} />
        ))}
      </div>
    </div>
  )
}
